import { U21Chip, U21Spacer } from 'app/shared/u21-ui/components';
import styled from 'styled-components';

interface Props {
  disableNew?: boolean;
}

export const AIHeader = (props: Props) => {
  const { disableNew } = props;
  return (
    <U21Spacer horizontal>
      <span>
        UNIT<Red>AI</Red>
      </span>
      {!disableNew && (
        <U21Chip color="special" rounded variant="ghost">
          New
        </U21Chip>
      )}
    </U21Spacer>
  );
};

const Red = styled.span`
  color: ${(props) => props.theme.palette.error.main};
`;
